// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-share-link[data-v-d06e85ba]{background-repeat:no-repeat;background-size:contain;display:block;height:50px;margin:0 .3rem;width:50px}", ""]);
// Exports
module.exports = exports;
